export const generalInformation = `
  generalInformation: collection(handle: "general_information") {
    structure {
      tree(site: $site) {
        entry {
          id
          slug
          title
          url
          ... on Entry_GeneralInformation_GeneralInformation {
            id
            main_components {
              ... on Set_MainComponents_Text {
                id
                type
                text
              }
              ... on Set_MainComponents_ImageWithText {
                id
                image {
                  ...Asset
                }
                text
                type
                image_position {
                  label
                  value
                }
              }
            }
          }
        }
        children {
          entry {
            id
            slug
            title
            url
            ... on Entry_GeneralInformation_GeneralInformation {
              id
              main_components {
                ... on Set_MainComponents_Text {
                  id
                  text
                  type
                }
                ... on Set_MainComponents_ImageWithText {
                  id
                  image {
                    ...Asset
                  }
                  text
                  type
                  image_position {
                    label
                    value
                  }
                }
              }
            }
          }
          children {
            entry {
              id
              slug
              title
              url
              ... on Entry_GeneralInformation_GeneralInformation {
                id
                main_components {
                  ... on Set_MainComponents_Text {
                    id
                    text
                    type
                  }
                  ... on Set_MainComponents_ImageWithText {
                    id
                    image {
                      ...Asset
                    }
                    text
                    type
                    image_position {
                      label
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
